stableExecute